import { StandardEvents } from '@shopify/events';

/**
 * <tier-pricing> custom element.
 *
 * The volume-pricing table is rendered server-side from the product's
 * selected_or_first_available_variant. When the customer picks a different
 * variant, Horizon re-renders the whole section with that variant, so the
 * fresh HTML already contains this block recomputed for the new price.
 * We just listen for the productSelect event and swap in our updated markup —
 * no client-side price math needed, so each variant shows its own tiers.
 */
class TierPricing extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    if (!this.section) return;
    this.section.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const updated = detail.html.querySelector(`tier-pricing[data-block-id="${this.dataset.blockId}"]`);
        if (updated) this.innerHTML = updated.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[tier-pricing] event promise rejected:', error);
      });
  };
}

if (!customElements.get('tier-pricing')) {
  customElements.define('tier-pricing', TierPricing);
}
